export default __webpack_public_path__ + "static/media/28.04f21903.jpg";